module.exports = __webpack_public_path__ + "img/DerAufprall3.57b73a03.jpg";